import { screenshotsAccordion } from '../utils/screenshots';

document.addEventListener('DOMContentLoaded', function (e) {
  screenshotsAccordion();
});
